<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
	<egranty-list
		header="Moje komisje"
		empty-warning="Brak komisji"
		:get-tile-title="(committee) => committee.name"
		:items="committees"
		icon="event_seat"
		color="orange">

		<template v-slot:avatar="slotData">
			<v-icon color="orange">event_seat</v-icon>
		</template>

		<template slot="actions" slot-scope="{ item }">
			<v-list-tile-action>
				<egranty-icon-button
					icon="assignment"
					:color="item.leader ? 'green darken-1' : 'primary'"
					label="Zbiorcza ocena"
					for="contest-committees-view-sumary-evaluation"
					id="contest-committees-view-sumary-evaluation"
					@click="viewCommitteeSummaryEvaluation(item.id)"/>
			</v-list-tile-action>
		</template>
	</egranty-list>
</template>

<script>
	import {Committee} from "../../../api/generated/Committee";
	import EgrantyList from "../../../genericComponents/EgrantyList";
	import EgrantyIconButton from "../../../genericComponents/EgrantyIconButton";

	export default {
		name: "ContestCommitteesView",

		components: {EgrantyList, EgrantyIconButton},

		data () {
			return {
				contestData: {
					id: this.$route.params.id,
				},
				committees: [],
			};
		},

		created () {
			loadCommittees(this);
		},

		methods: {
			viewCommitteeSummaryEvaluation (committeeId) {
				this.$router.push("/app/contest/" + this.contestData.id + "/evaluation-summary/committees/" + committeeId);
			},
		},
	};

	function loadCommittees (ctx) {
		Committee.getLeadingCommitteesName(ctx, ctx.contestData.id,
			success => {
				ctx.committees = success;
			}, error => {
				ctx.$messagesBus.$emit("error", "Nie udało się pobrać listy komisji", error);
			});
	}
</script>

